export const REQUEST_RESPONSE_ENCRYPTION_ACTIONS = {
SET_REQUEST_DUPLICATE_ERROR: 'SET_REQUEST_DUPLICATE_ERROR',
SET_RESPONSE_DUPLICATE_ERROR: 'SET_RESPONSE_DUPLICATE_ERROR',
SET_REQUEST_INPUT_ERROR: 'SET_REQUEST_INPUT_ERROR',
SET_RESPONSE_INPUT_ERROR: 'SET_RESPONSE_INPUT_ERROR',
SET_REQUEST_BUTTON_INVALID: 'SET_REQUEST_BUTTON_INVALID',
SET_RESPONSE_BUTTON_INVALID: 'SET_RESPONSE_BUTTON_INVALID'
};

export interface IRequestResponseState {
    requestDuplicateError: string,
    requestInputErr: string,
    requestBtnInvalid: boolean,
    responseDuplicateError:string,
    responseInputErr:string,
    responseBtnInvalid:boolean
  }

  export const requestResponseFormInitialState: IRequestResponseState = {
    requestDuplicateError: '',
    requestInputErr: '',
    requestBtnInvalid: true,
    responseDuplicateError: '',
    responseInputErr: '',
    responseBtnInvalid: true
  };

  interface IRequestResponseAction {
    type: string,
    requestDuplicateErrorPayload?: { requestDuplicateError:string },
    responseDuplicateErrorPayload?: { responseDuplicateError: string },
    requestInputErrPayload?: { requestInputErr:string },
    responseInputErrPayload?: { responseInputErr: string },
    requestBtnInvalidPayload?: { requestBtnInvalid:boolean },
    responseBtnInvalidPayload?: { responseBtnInvalid: boolean },
  }
/**
 * Reducer function to manage RequestResponse state
 * @param state : IRequestResponseState
 * @param action : actions to perform on state
 * @returns IRequestResponseState
 */
export const getRequestResponseEncryptionStateReducer = (state: IRequestResponseState, action: IRequestResponseAction) :IRequestResponseState => {
    switch (action.type) {
      case REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_DUPLICATE_ERROR: {
        return {
          ...state,
          requestDuplicateError: action.requestDuplicateErrorPayload?.requestDuplicateError ? action.requestDuplicateErrorPayload?.requestDuplicateError : ''
        };
      }

      case REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_DUPLICATE_ERROR: {
        return {
          ...state,
          responseDuplicateError: action.responseDuplicateErrorPayload?.responseDuplicateError ? action.responseDuplicateErrorPayload?.responseDuplicateError : ''
        };
      }

      case REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_INPUT_ERROR: {
        return {
          ...state,
          requestInputErr: action.requestInputErrPayload?.requestInputErr ? action.requestInputErrPayload?.requestInputErr : ''
        };
      }

      case REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_INPUT_ERROR: {
        return {
          ...state,
          responseInputErr: action.responseInputErrPayload?.responseInputErr ? action.responseInputErrPayload?.responseInputErr : '',
        };
      }

      case REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_BUTTON_INVALID: {
        return {
          ...state,
          requestBtnInvalid: action.requestBtnInvalidPayload?.requestBtnInvalid ? action.requestBtnInvalidPayload?.requestBtnInvalid : false
        };
      }

      case REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_BUTTON_INVALID: {
        return {
          ...state,
          responseBtnInvalid: action.responseBtnInvalidPayload?.responseBtnInvalid ? action.responseBtnInvalidPayload?.responseBtnInvalid : false
        };
      }

      default:
        return state;
    }
  };
